var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"12","cy":"12","r":"12","fill":"#0D0D0D","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.7142 8.13958C17.0298 8.37076 17.0938 8.80806 16.8571 9.11631L11.5 16.093C11.3796 16.2499 11.1971 16.35 10.9974 16.3688C10.7976 16.3877 10.5989 16.3236 10.4499 16.1923L7.23565 13.358C6.94283 13.0998 6.91975 12.6586 7.1841 12.3726C7.44845 12.0866 7.90012 12.0641 8.19293 12.3223L10.8265 14.6445L15.7143 8.27911C15.9509 7.97086 16.3987 7.90839 16.7142 8.13958Z","fill":"white","key":1})]);
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Check;

Check.default = Check;
